export default __webpack_public_path__ + "static/media/1 (18).b0be080d.jpg";